/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import useSiteMetadata from "../hooks/use-site-metadata"
import { DEFAULT_SEO_IMAGE } from "../utils/constants"

interface Props {
  description?: string
  lang?: string
  meta?: any
  title?: string
  image?: string
}

function Seo({ description, lang, meta, title, image }: Props) {
  const {
    siteUrl,
    description: defaultDescription,
    title: defaultTitle,
    author: siteAuthor,
    gaTrackingId,
  } = useSiteMetadata()

  const defaultImage = `https://blog.asial.co.jp/ogp-logo.jpg`
  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    image: image || defaultImage,
    author: siteAuthor || "",
  }

  return (
    <Helmet
      htmlAttributes={{
        lang: "ja",
        prefix: "og: https://ogp.me/ns#",
      }}
      title={seo.title || " "}
      titleTemplate={title ? `%s - ${defaultTitle}` : defaultTitle}
      meta={[
        {
          name: `description`,
          content: seo.description,
        },
        {
          property: `og:title`,
          content: seo.title,
        },
        {
          property: `og:description`,
          content: seo.description,
        },
        {
          property: `og:site_name`,
          content: `アシアルTechブログ`,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:image`,
          content: seo.image,
        },
        {
          name: `twitter:card`,
          content: `summary_large_image`,
        },
        {
          name: `twitter:title`,
          content: seo.title,
        },
        {
          name: `twitter:description`,
          content: seo.description,
        },
        {
          name: `twitter:image`,
          content: seo.image,
        },
      ].concat(meta)}
    >
      <script
        defer
        src={`https://www.googletagmanager.com/gtag/js?id=${gaTrackingId}`}
      ></script>
      <script>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${gaTrackingId}');
        `}
      </script>
    </Helmet>
  )
}

Seo.defaultProps = {
  lang: `ja`,
  meta: [],
  description: ``,
}

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
}

export default Seo
